import { MIN_VALID_MILLIS, SHORT_DAY_MIN_VALID_MILLIS } from '../config/constants';
import { ActivityTime } from './activity-time';

export class Validation {
  constructor(
    public hash: string,
    public modelHash: string,
    public modelName: string,
    public modelImagePath: string,
    public brandImage: string,
    public brandBWImage: string,
    public modelOrder: number,
    public validationDay: number,
    public validated: boolean,
    public hasIncompleteData: boolean,
    public isShortDay: boolean,
    public activitiesTime: ActivityTime[],
    public totalTime: number,
    public modelReference?: string
  ) { }

  get canBeValidated() {
    return !this.validated && !this.hasIncompleteData && this.hasMinTimeToBeValidated();
  }

  get modelFullName() {
    return this.modelName + ' - ' + this.modelReference;
  }

  private hasMinTimeToBeValidated() {
    return (this.isShortDay) ? this.totalTime >= SHORT_DAY_MIN_VALID_MILLIS : this.totalTime >= MIN_VALID_MILLIS;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/validation.ts